import React, { useState, useMemo, useEffect } from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import QuizCard from "../common/quizCard";
import Skeleton from "react-loading-skeleton";
import { Pagination } from "../../../core/common/ults/pagination";
import { useTranslation } from "react-i18next";
import { useHandleQuiz } from "../../../core/hooks/useHandleQuiz";
import { Link } from "react-router-dom";
import { useHandleAssign } from "../../../core/hooks/useHandleAssign";

const StudentQuiz = () => {
  const { moodleQuizzes, isMoodleQuizzesLoading } = useHandleQuiz();
  const { moodleAssigns, isMoodleAssignLoading } = useHandleAssign();
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("quizzActiveTab");
    return savedTab || "quiz";
  });

  useEffect(() => {
    sessionStorage.setItem("quizzActiveTab", activeTab);
  }, [activeTab]);

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    setCurrentPage(1); // Reset về trang 1 khi chuyển tab
  };

  const allAssignments = useMemo(() => {
    if (!moodleAssigns?.courses) return [];
    return moodleAssigns.courses.reduce((acc: any[], course: any) => {
      if (course.assignments) {
        return [...acc, ...course.assignments];
      }
      return acc;
    }, []);
  }, [moodleAssigns]);

  const itemsPerPage = 6; // Số lượng courses hiển thị trên mỗi trang
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate data to display for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentQuizItems = moodleQuizzes?.quizzes.slice(
    startIndex,
    startIndex + itemsPerPage
  ).map((quiz: any) => ({
    ...quiz,
    type: "quiz"
  }));
  const currentAssignItems = allAssignments.slice(
    startIndex,
    startIndex + itemsPerPage
  ).map((assign: any) => ({
    ...assign,
    type: "assignment"
  }));

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("quiz.title")} />
              <div className="page-title d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 gap-md-0">
                <h5>{t("quiz.title")}</h5>
                <div className="tab-list">
                  <ul className="nav mb-0 gap-2" role="tablist">
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        className={activeTab === "quiz" ? "active" : ""}
                        data-bs-toggle="tab"
                        data-bs-target="#quiz"
                        aria-selected="false"
                        role="tab"
                        onClick={() => handleTabChange("quiz")}
                      >
                        {t(`quiz.card.type.quiz`)}
                      </Link>
                    </li>
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        className={activeTab === "assign" ? "active" : ""}
                        data-bs-toggle="tab"
                        data-bs-target="#assign"
                        aria-selected="true"
                        role="tab"
                        onClick={() => handleTabChange("assign")}
                      >
                        {t(`quiz.card.type.assignment`)}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="tab-content">
                <div
                  className={`tab-pane fade ${
                    activeTab === "quiz" ? "active show" : ""
                  }`}
                  id="quiz"
                  role="tabpanel"
                >
                  <div className="row">
                    {isMoodleQuizzesLoading ? (
                      <Skeleton height={200} className="mb-3" />
                    ) : (
                      <>
                        {currentQuizItems?.map((quiz: any, index: any) => {
                          return (
                            <div key={index} className="col-12">
                              <QuizCard data={quiz} />
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                  <div className="row align-items-center mt-2">
                    <Pagination
                      totalItems={moodleQuizzes?.quizzes?.length || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={(page: number) => setCurrentPage(page)}
                    />
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    activeTab === "assign" ? "active show" : ""
                  }`}
                  id="assign"
                  role="tabpanel"
                >
                  <div className="mb-3 d-flex justify-content-end">
                    {/* Xóa checkbox showUnenrolledOnly */}
                  </div>
                  <div className="row">
                    {isMoodleQuizzesLoading ? (
                      <Skeleton height={200} className="mb-3" />
                    ) : (
                      <>
                        {currentAssignItems?.map((assign: any, index: any) => (
                          <div key={index} className="col-12">
                            <QuizCard data={assign} />
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  <div className="row align-items-center mt-2">
                    <Pagination
                      totalItems={allAssignments?.length || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={(page: number) => setCurrentPage(page)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentQuiz;
